import { c as _c } from "react/compiler-runtime";
import { Accordion, AspectRatio, Box, BoxProps, Button, Center, Separator, HStack, Heading, HeadingProps, Icon, SimpleGrid, Spacer, Stack, StackProps, Text, VStack, chakra, Dialog } from '@chakra-ui/react';
import { MobileBottomBar } from '@src/components/sco/LayoutBlocks/MobileBottomBar';
import { StartupscomLogo } from '@src/components/sco/StartupscomLogo';
import { ChakraNextImage } from '@src/components/sco/utilities/ChakraNextImage';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { TrackEvent } from '@src/lib/TrackEvent';
import tracker from '@src/lib/tracker';
import { calloutGradient } from '@src/theme/components/Text';
import { range } from 'lodash';
import React, { useState } from 'react';
import { FaStar } from 'react-icons/fa6';
import { FiCheckCircle } from 'react-icons/fi';
import { LuCalendar, LuCheckCheck, LuChevronRight, LuUsers } from 'react-icons/lu';
import ReactPlayer from 'react-player';
export { getServerSideProps } from '@src/lib/server-side-rendering';
const ctaHref = `/landing/first-10k/payment`;
const variantKey = 'first-10k';
export default function Page() {
  const $ = _c(79);
  const activeContentContext = useActiveContentContext();
  const [showVideo, setShowVideo] = useState(false);
  let t0;
  if ($[0] !== activeContentContext) {
    t0 = () => {
      activeContentContext.setItem({
        __typename: "LandingPage",
        title: "Get Your First $10K in Revenue with live help.",
        description: "Twice a week we roll up our sleeves, dissect your marketing, and ship tactics that move the needle before the next session."
      });
      return () => activeContentContext.setItem(null);
    };
    $[0] = activeContentContext;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useUniversalEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TrackEvent action="lpViewed" onlyOnScreen={true} traits={{
      variantKey
    }} />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = require("@public/assets/backgrounds/25.jpg");
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      backgroundColor: "backgroundSecondaryAlpha.600"
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [6, 6, 8, 10, 12, 14];
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <StartupscomLogo />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = ["3xl", "3xl", "4xl", "4xl", "5xl", "6xl"];
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <chakra.span display={["inline", "block"]}>Get Your First $10K in Revenue</chakra.span>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t10;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Heading as="h1" size={t7} textShadow="0 1px 0.125em rgba(0,0,0,.25)">{t8}{" "}<chakra.span {...calloutGradient}>with live help.</chakra.span></Heading>;
    t10 = <Spacer height="1em" />;
    $[10] = t10;
    $[11] = t9;
  } else {
    t10 = $[10];
    t9 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Box marginX="auto" maxWidth="920px">{t9}{t10}<Heading as="h2" color="colorPalette.fg/80" fontSize={["xl", "xl", "xl", "2xl", "3xl"]} fontWeight="500" textShadow="0 1px 0.125em rgba(0,0,0,.25)">Twice a week we roll up our sleeves, dissect your marketing, and ship tactics that move the needle before the next session.</Heading></Box>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = ["stretch", "stretch", "center"];
    t13 = ["column", "column", "row"];
    $[13] = t12;
    $[14] = t13;
  } else {
    t12 = $[13];
    t13 = $[14];
  }
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = ["stretch", "stretch", "center"];
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Box backgroundPosition="50% 50%" borderBottom="1px solid" borderBottomColor="blackAlpha.500" backgroundSize="cover" backgroundImage={t3.default.src}><Block boxProps={t4}><VStack gap={t5} textAlign="center">{t6}{t11}<Stack align={t12} direction={t13} gap={4} justify={t14}><Button asChild={true} size="xl" variant="cta"><NextLink href={ctaHref} onClick={_temp}>Save My Seat<LuChevronRight /></NextLink></Button></Stack></VStack></Block></Box>;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      children: "Real problems, solved in Real-time."
    };
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  let t18;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Text>{"Forget theory. On Mondays & Fridays you bring the problem; we bring the whiteboard, ads manager, and coffee."}</Text>;
    t18 = ["Zero slides. 100% interaction.", "Real campaigns launched in-session", "Replays available for fast recall"].map(_temp2);
    $[18] = t17;
    $[19] = t18;
  } else {
    t17 = $[18];
    t18 = $[19];
  }
  let t19;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Block headingProps={t16}><BlockCard>{t17}{t18}<Text color="white"><strong>Outcome: You should leave each workshop with at least one experiment to run.</strong></Text></BlockCard></Block>;
    $[20] = t19;
  } else {
    t19 = $[20];
  }
  let t20;
  let t21;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      background: "backgroundSecondary"
    };
    t21 = {
      children: "Meet Your Guide"
    };
    $[21] = t20;
    $[22] = t21;
  } else {
    t20 = $[21];
    t21 = $[22];
  }
  let t22;
  let t23;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = ["column", "column", "row"];
    t23 = [6, 6, 12];
    $[23] = t22;
    $[24] = t23;
  } else {
    t22 = $[23];
    t23 = $[24];
  }
  let t24;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <ChakraNextImage alt="Ryan Rutan" borderRadius="full" boxShadow="lg" maxWidth="240px" src={require("@public/assets/illustration/podcasts/ryan-rutan-full.jpg")} width={600} />;
    $[25] = t24;
  } else {
    t24 = $[25];
  }
  let t25;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <Block boxProps={t20} headingProps={t21}><Stack align="center" direction={t22} gap={t23} justify="center" marginX="auto" maxWidth="container.md">{t24}<VStack align="stretch" flex={1}><Heading>Ryan Rutan</Heading><Text fontSize="xl">I've helped 25,000+ founders crack their first marketing wins. My rule: advice is worthless until it's implemented, so we implement together. Each month I invite a 'channel sniper' (TikTok ads, cold email, SEO sprints…) to push past my blind spots, and yours.</Text></VStack></Stack></Block>;
    $[26] = t25;
  } else {
    t25 = $[26];
  }
  let t26;
  let t27;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = {
      background: "colorPalette.bg"
    };
    t27 = {
      children: "Community + Resources = Momentum"
    };
    $[27] = t26;
    $[28] = t27;
  } else {
    t26 = $[27];
    t27 = $[28];
  }
  let t28;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = [1, 1, 2];
    $[29] = t28;
  } else {
    t28 = $[29];
  }
  let t29;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = [6, 6, 12];
    $[30] = t29;
  } else {
    t29 = $[30];
  }
  let t30;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <VStack align="stretch" gap={6} justify="center">{[{
        icon: LuUsers,
        text: "Private founder community sharing real wins & failures"
      }, {
        icon: LuCheckCheck,
        text: "Weekly accountability check-ins"
      }, {
        icon: LuCalendar,
        text: "Bi-weekly expert guest sessions"
      }].map(_temp3)}</VStack>;
    $[31] = t30;
  } else {
    t30 = $[31];
  }
  let t31;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <Block boxProps={t26} headingProps={t27}><SimpleGrid columns={t28} fontSize="xl" gap={t29} marginX="auto" maxWidth="860px">{t30}<Box><Text>The magic happens between sessions. Our private community becomes your marketing brain trust, where founders share campaign results, troubleshoot ad spend, and celebrate revenue milestones together.</Text></Box></SimpleGrid></Block>;
    $[32] = t31;
  } else {
    t31 = $[32];
  }
  let t32;
  let t33;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = {
      background: "backgroundSecondary"
    };
    t33 = {
      children: "On-Demand Playbooks"
    };
    $[33] = t32;
    $[34] = t33;
  } else {
    t32 = $[33];
    t33 = $[34];
  }
  let t34;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <Block boxProps={t32} headingProps={t33}><BlockCard><Text fontSize="xl" textAlign="center">50+ bite-size courses and checklists. Think of them as pre-work so you can spend live sessions on doing, not downloading.</Text></BlockCard></Block>;
    $[35] = t34;
  } else {
    t34 = $[35];
  }
  let t35;
  let t36;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = {
      background: "colorPalette.bg"
    };
    t36 = {
      children: "Expert Guest Roster"
    };
    $[36] = t35;
    $[37] = t36;
  } else {
    t35 = $[36];
    t36 = $[37];
  }
  let t37;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = [1, 1, 3];
    $[38] = t37;
  } else {
    t37 = $[38];
  }
  let t38;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <Block boxProps={t35} headingProps={t36}><SimpleGrid columns={t37} gap={4} textAlign="center">{[{
          name: "Sarah Kim",
          tagline: "TikTok Ads Specialist",
          bio: "Generated $2M+ in revenue for DTC brands through viral TikTok campaigns"
        }, {
          name: "Marcus Chen",
          tagline: "Cold Email Expert",
          bio: "50%+ open rates across B2B campaigns, $5M+ in pipeline generated"
        }, {
          name: "Alex Rodriguez",
          tagline: "SEO Sprint Master",
          bio: "0 to 100K monthly organic traffic in 90 days for 20+ startups"
        }].map(_temp4)}</SimpleGrid></Block>;
    $[39] = t38;
  } else {
    t38 = $[39];
  }
  let t39;
  let t40;
  let t41;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = {
      background: "backgroundSecondary"
    };
    t40 = {
      children: "Founder Wins"
    };
    t41 = {
      maxWidth: "container.xl"
    };
    $[40] = t39;
    $[41] = t40;
    $[42] = t41;
  } else {
    t39 = $[40];
    t40 = $[41];
    t41 = $[42];
  }
  let t42;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = [1, 2, 3];
    $[43] = t42;
  } else {
    t42 = $[43];
  }
  let t43;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <Block boxProps={t39} headingProps={t40} innerBoxProps={t41}><SimpleGrid columns={t42} gap={4} textAlign="center">{[{
          name: "Manu B.",
          quote: "Week 3 and the landing\u2011page rewrite paid for my annual membership."
        }, {
          name: "Julia R.",
          quote: "First $11.4K closed while everyone else was still validating."
        }, {
          name: "Kelly L.",
          quote: "I loved the format and how well Ryan facilitated it. I was feverishly taking notes and learned so much in one session."
        }, {
          name: "Jeff T.",
          quote: "Ryan is extremely knowledgeable, clearly draws on real\u2011world experience, and communicates it brilliantly."
        }, {
          name: "Alejandro S.",
          quote: "Interactive workshop with hands\u2011on feedback for our specific issues."
        }, {
          name: "Vonda G.",
          quote: "The personal, 1:1 Q&A made me rethink how to bring in business."
        }, {
          name: "Kerry G.",
          quote: "Specific, actionable insight on what to do next with a targeted growth strategy."
        }, {
          name: "Samantha W.",
          quote: "The practical help. My 30\u2011second pitch finally crystallised into something I can test."
        }, {
          name: "Sam M.",
          quote: "Ryan's advice is succinct, on\u2011point, and right on the money."
        }].map(_temp6)}</SimpleGrid></Block>;
    $[44] = t43;
  } else {
    t43 = $[44];
  }
  let t44;
  let t45;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = {
      background: "colorPalette.bg"
    };
    t45 = {
      children: "Simple Plan & Pricing"
    };
    $[45] = t44;
    $[46] = t45;
  } else {
    t44 = $[45];
    t45 = $[46];
  }
  let t46;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = {
      spacing: 8
    };
    $[47] = t46;
  } else {
    t46 = $[47];
  }
  let t47;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = [1, 1, 3];
    $[48] = t47;
  } else {
    t47 = $[48];
  }
  let t48;
  let t49;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = <SimpleGrid columns={t47} gap={4}>{[{
        title: "Join Live Sessions",
        description: "Mondays & Fridays, bring your marketing challenges"
      }, {
        title: "Implement Together",
        description: "We build campaigns, write copy, and launch experiments live"
      }, {
        title: "Scale What Works",
        description: "Use community feedback to optimize and grow revenue"
      }].map(_temp7)}</SimpleGrid>;
    t49 = <Separator />;
    $[49] = t48;
    $[50] = t49;
  } else {
    t48 = $[49];
    t49 = $[50];
  }
  let t50;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = <VStack><HStack gap={1} justify="center"><Heading lineHeight={1} size="5xl">$49</Heading><Text alignSelf="flex-end" color="colorPalette.fg/50">/month</Text></HStack><Text textAlign="center">Cancel anytime. No setup fees.</Text></VStack>;
    $[51] = t50;
  } else {
    t50 = $[51];
  }
  let t51;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = <Block boxProps={t44} headingProps={t45}><BlockCard stackProps={t46}>{t48}{t49}{t50}<Center><Button asChild={true} size="xl" variant="cta"><NextLink href={ctaHref} onClick={_temp8}>Save My Seat<LuChevronRight /></NextLink></Button></Center></BlockCard></Block>;
    $[52] = t51;
  } else {
    t51 = $[52];
  }
  let t52;
  let t53;
  let t54;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = {
      background: "backgroundSecondary"
    };
    t53 = {
      children: "Frequently Asked Questions"
    };
    t54 = {
      maxWidth: "container.lg"
    };
    $[53] = t52;
    $[54] = t53;
    $[55] = t54;
  } else {
    t52 = $[53];
    t53 = $[54];
    t54 = $[55];
  }
  let t55;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = [];
    $[56] = t55;
  } else {
    t55 = $[56];
  }
  let t56;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = <Block boxProps={t52} headingProps={t53} innerBoxProps={t54}><Accordion.Root multiple={true} defaultValue={t55} variant="plain" width="full">{[{
          question: "What if I can't attend the live sessions?",
          answer: "Every session is recorded and available within 2 hours. Plus, our community is active 24/7 for questions and support between sessions."
        }, {
          question: "I'm a complete marketing beginner. Will this work for me?",
          answer: "Perfect! We start with fundamentals and build up. The on-demand playbooks give you foundation knowledge, while live sessions focus on implementation specific to your business."
        }, {
          question: "Is there a money-back guarantee?",
          answer: "Yes! If you attend 4 sessions in your first month and don't see measurable progress, we'll refund your first month. No questions asked."
        }, {
          question: "I see this normally costs $199/month. Why is it $49 now?",
          answer: "$199 is for EVERYTHING we offer, but we noticed a lot of Founders just wanted to focus on getting customers, and not chase funding, pitch investors, build team etc. If you are one of those founders who just wants to dig deep and drive revenue, this allows you to do that for less cost. Think of this as our \"bootstrap\" friendly offer!"
        }].map(_temp9)}</Accordion.Root><Spacer height="10em" /></Block>;
    $[57] = t56;
  } else {
    t56 = $[57];
  }
  let t57;
  let t58;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t57 = [4, 4, 6];
    t58 = [4, 4, 6];
    $[58] = t57;
    $[59] = t58;
  } else {
    t57 = $[58];
    t58 = $[59];
  }
  let t59;
  let t60;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t59 = ["stretch", "stretch", "center"];
    t60 = ["column", "column", "row"];
    $[60] = t59;
    $[61] = t60;
  } else {
    t59 = $[60];
    t60 = $[61];
  }
  let t61;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t61 = ["stretch", "stretch", "space-between"];
    $[62] = t61;
  } else {
    t61 = $[62];
  }
  let t62;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t62 = <Heading fontSize={["lg", "lg", "2xl"]} textAlign="center">Ready to turn on traffic and hit your first $10K?</Heading>;
    $[63] = t62;
  } else {
    t62 = $[63];
  }
  let t63;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t63 = {
      bgColor: "white"
    };
    $[64] = t63;
  } else {
    t63 = $[64];
  }
  let t64;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t64 = ["md", "md", "lg"];
    $[65] = t64;
  } else {
    t64 = $[65];
  }
  let t65;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t65 = <MobileBottomBar><Box marginX="auto" maxWidth="container.lg" paddingBottom={6} paddingTop={t57} paddingX={t58}><Stack align={t59} direction={t60} gap={4} justify={t61}>{t62}<Button asChild={true} _hover={t63} bgColor="colorPalette.fg/80" color="black" size={t64}><NextLink href={ctaHref} onClick={_temp10}>Save My Seat<LuChevronRight /></NextLink></Button></Stack></Box></MobileBottomBar>;
    $[66] = t65;
  } else {
    t65 = $[66];
  }
  let t66;
  let t67;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t66 = t68 => {
      const {
        open
      } = t68;
      return setShowVideo(open);
    };
    t67 = <Dialog.Backdrop />;
    $[67] = t66;
    $[68] = t67;
  } else {
    t66 = $[67];
    t67 = $[68];
  }
  let t68;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t68 = [4, 4, 8];
    $[69] = t68;
  } else {
    t68 = $[69];
  }
  let t69;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t69 = <Dialog.CloseTrigger />;
    $[70] = t69;
  } else {
    t69 = $[70];
  }
  let t70;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t70 = <Box><AspectRatio ratio={1.7777777777777777}><ReactPlayer controls={true} height="100%" playing={true} style={{
          borderRadius: "1em",
          border: "1em solid blackAlpha.500"
        }} url="https://youtu.be/dQw4w9WgXcQ" width="100%" /></AspectRatio></Box>;
    $[71] = t70;
  } else {
    t70 = $[71];
  }
  let t71;
  let t72;
  if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
    t71 = ["stretch", "stretch", "center"];
    t72 = ["column", "column", "row"];
    $[72] = t71;
    $[73] = t72;
  } else {
    t71 = $[72];
    t72 = $[73];
  }
  let t73;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t73 = ["stretch", "stretch", "space-between"];
    $[74] = t73;
  } else {
    t73 = $[74];
  }
  let t74;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t74 = <Heading fontSize={["lg", "lg", "2xl"]} textAlign="center">Ready to turn on traffic and hit your first $10K?</Heading>;
    $[75] = t74;
  } else {
    t74 = $[75];
  }
  let t75;
  if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
    t75 = <Dialog.Positioner><Dialog.Content maxWidth="container.lg"><Dialog.Body bgColor="colorPalette.bg" borderRadius="lg" paddingX={t68} paddingY={10}>{t69}<VStack align="stretch" gap={8}>{t70}<Stack align={t71} direction={t72} gap={4} justify={t73}>{t74}<Button asChild={true} size="xl" variant="cta"><NextLink href={ctaHref} onClick={_temp11}>Save My Seat<LuChevronRight /></NextLink></Button></Stack></VStack></Dialog.Body></Dialog.Content></Dialog.Positioner>;
    $[76] = t75;
  } else {
    t75 = $[76];
  }
  let t76;
  if ($[77] !== showVideo) {
    t76 = <>{t2}{t15}{t19}{t25}{t31}{t34}{t38}{t43}{t51}{t56}{t65}<Dialog.Root open={showVideo} onOpenChange={t66}>{t67}{t75}</Dialog.Root></>;
    $[77] = showVideo;
    $[78] = t76;
  } else {
    t76 = $[78];
  }
  return t76;
}
function _temp11() {
  return tracker.lpClicked({
    variantKey
  });
}
function _temp10() {
  return tracker.lpClicked({
    variantKey
  });
}
function _temp9(item_1, index) {
  return <Accordion.Item key={index} bgColor="blackAlpha.400" border="1px solid transparent" borderRadius="md" marginBottom={2} value={`item-${index}`} _hover={{
    borderColor: "colorPalette.border"
  }}><Accordion.ItemTrigger _expanded={{
      paddingBottom: 2
    }} padding={6}><Text flex={1} fontWeight={600} textAlign="left">{item_1.question}</Text><Accordion.ItemIndicator /></Accordion.ItemTrigger><Accordion.ItemContent paddingBottom={6} paddingX={6}><Accordion.ItemBody><Text color="textPrimary">{item_1.answer}</Text></Accordion.ItemBody></Accordion.ItemContent></Accordion.Item>;
}
function _temp8() {
  return tracker.lpClicked({
    variantKey
  });
}
function _temp7(card_1, idx_3) {
  return <Box key={idx_3}><VStack gap={4} textAlign="center"><AspectRatio background="purpleLightAlpha.500" borderRadius="full" padding={6} ratio={1}><Heading color="black">{idx_3 + 1}</Heading></AspectRatio><Box><Heading>{card_1.title}</Heading><Text fontSize="md">{card_1.description}</Text></Box></VStack></Box>;
}
function _temp6(card_0, idx_2) {
  return <BlockCard key={idx_2} stackProps={{
    spacing: 4,
    fontSize: "md",
    paddingY: 6,
    paddingX: 4,
    textAlign: "left"
  }}><HStack justify="flex-start">{range(0, 5).map(_temp5)}</HStack><Text fontSize="lg" fontStyle="italic" fontWeight="normal">"{card_0.quote}"</Text><Text fontSize="md" fontWeight="bold">{"\u2014 "}{card_0.name}</Text></BlockCard>;
}
function _temp5(i) {
  return <Icon asChild={true} color="orange"><FaStar key={i} /></Icon>;
}
function _temp4(card, idx_1) {
  return <BlockCard key={idx_1} stackProps={{
    spacing: 2,
    fontSize: "md",
    paddingX: 3
  }}><Heading as="h3">{card.name}</Heading><Text color="colorPalette.border" fontWeight="bold">{card.tagline}</Text><Text>{card.bio}</Text></BlockCard>;
}
function _temp3(item_0, idx_0) {
  return <HStack key={idx_0} align="flex-start" gap={4}><Icon asChild={true} color="colorPalette.border" marginTop={1.5}><item_0.icon /></Icon><Text>{item_0.text}</Text></HStack>;
}
function _temp2(item, idx) {
  return <HStack key={idx} gap={4}><Icon asChild={true} color="colorPalette.border"><FiCheckCircle /></Icon><Text flex={1}>{item}</Text></HStack>;
}
function _temp() {
  return tracker.lpClicked({
    variantKey
  });
}
export const Block = props => {
  const $ = _c(12);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [12, 12, 12, 16, 24, 28];
    t1 = [10, 10, 10, 14, 20, 24];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [2, 2, 4, 6, 8];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props.headingProps) {
    t3 = props.headingProps && <Heading marginBottom={[4, 4, 6, 6]} size={["2xl", "2xl", "3xl", "3xl", "5xl"]} textAlign="center" {...props.headingProps} />;
    $[3] = props.headingProps;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props.children || $[6] !== props.innerBoxProps || $[7] !== t3) {
    t4 = <Box marginX="auto" maxWidth="container.xl" paddingX={t2} {...props.innerBoxProps}>{t3}{props.children}</Box>;
    $[5] = props.children;
    $[6] = props.innerBoxProps;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== props.boxProps || $[10] !== t4) {
    t5 = <Box background="colorPalette.bg" paddingBottom={t0} paddingTop={t1} {...props.boxProps}>{t4}</Box>;
    $[9] = props.boxProps;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export const BlockCard = props => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["lg", "lg", "xl"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [6, 6, 8, 10];
    t2 = [6, 6, 8, 10];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props.children || $[4] !== props.stackProps) {
    t3 = <VStack align="stretch" bgColor="colorPalette.container" border="1px solid" borderColor="primaryAlpha.600" borderRadius="lg" boxShadow="md" fontSize={t0} gap={6} justify="stretch" marginX="auto" maxWidth="860px" paddingX={t1} paddingY={t2} width="full" {...props.stackProps}>{props.children}</VStack>;
    $[3] = props.children;
    $[4] = props.stackProps;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};